import { Button, List, ListItemButton, ListItemText, Paper, Typography } from "@mui/material";
import Add from "@mui/icons-material/Add";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Redirect } from "../../misc/Redirect";
import { useWorkspace } from "../../misc/Workspace";
import { NewTeamDialog } from "../../misc/WorkspaceSwitcher";

// TeamListPage lists the user's teams in the "All" workspace. Opening one goes to its
// settings, in its own workspace.
export function TeamListPage() {
    const ws = useWorkspace();
    const navigate = useNavigate();
    const [creating, setCreating] = useState(false);

    // a team's workspace has the settings of that team instead
    if (ws.team) return <Redirect to={ws.path("/team")} />;

    return (
        <>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Typography variant="h5" style={{ flex: 1 }}>Teams</Typography>
                <Button variant="contained" size="small" startIcon={<Add />}
                        onClick={() => setCreating(true)}>New team</Button>
            </div>

            <div style={{ height: 16 }} />
            {ws.loading && ws.teams.length === 0 && <Typography variant="body2">Loading...</Typography>}
            {ws.error && <Typography variant="body2" color="error">{ws.error}</Typography>}

            <Paper>
                <List disablePadding>
                    {ws.teams.map(team => (
                        <ListItemButton key={team.id} divider onClick={() => navigate("/w/" + team.id + "/team")}>
                            <ListItemText
                                primary={team.personal ? "Personal" : team.name}
                                secondary={team.memberCount + (team.memberCount === 1 ? " member" : " members")}
                            />
                        </ListItemButton>
                    ))}
                </List>
            </Paper>

            <NewTeamDialog open={creating} onClose={() => setCreating(false)} />
        </>
    );
}
